import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IQuestionnaireSection } from '../interfaces/questionnaireSection';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

export const fetchQuestionnaireSectionsRequest = () =>
  ({
    type: 'FETCH_QUESTIONNAIRE_SECTIONS_REQUEST'
  } as const);

export const fetchQuestionnaireSectionsSuccess = (payload: IQuestionnaireSection[]) =>
  ({
    type: 'FETCH_QUESTIONNAIRE_SECTIONS_SUCCESS',
    payload
  } as const);

export const fetchQuestionnaireSectionsFailure = (error: AxiosError | Error) => {
  sendError(error);
  return {
    type: 'FETCH_QUESTIONNAIRE_SECTIONS_FAILURE',
    error
  } as const;
};

const shouldFetchQuestionnaireSections = (state: CommonRootState) => {
  const {
    questionnaireSections: { isFetching, error, questionnaireSections }
  } = state;

  return !isFetching && !error && !questionnaireSections;
};

export const fetchQuestionnaireSections = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchQuestionnaireSectionsRequest());
    const response = await axios.get<IQuestionnaireSection[]>(
      `/api/v2/organizations/${organizationId}/questionnaireSections`
    );
    dispatch(fetchQuestionnaireSectionsSuccess(response.data));
  } catch (error) {
    dispatch(fetchQuestionnaireSectionsFailure(error));
  }
};

export const fetchQuestionnaireSectionsIfNeeded = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchQuestionnaireSections(getState())) {
    dispatch(fetchQuestionnaireSections(organizationId));
  }
};

export type Actions =
  | ReturnType<typeof fetchQuestionnaireSectionsRequest>
  | ReturnType<typeof fetchQuestionnaireSectionsSuccess>
  | ReturnType<typeof fetchQuestionnaireSectionsFailure>;
